// Configuration file for easy environment switching
export const config = {
  // API Configuration
  api: {
    // Development - Local Claude Backend
    development: 'http://localhost:3000',
    
    // Production - Azure Container App
    production: 'https://sleekshop-chatbot.orangerock-46a39d60.westus3.azurecontainerapps.io',
    
    // Current environment
    get baseUrl() {
      const envUrl = process.env.REACT_APP_API_BASE_URL;
      const nodeEnv = process.env.NODE_ENV;
      
      // Debug logging
      console.log('Config: Environment variables check:');
      console.log('  - REACT_APP_API_BASE_URL:', envUrl);
      console.log('  - NODE_ENV:', nodeEnv);
      console.log('  - Available env vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
      
      // TEMPORARY: Force development mode for testing
      console.log('Config: TEMPORARILY forcing development mode for backend testing');
      return this.development;
      
      // Original logic (commented out temporarily)
      // if (envUrl) {
      //   console.log('Config: Using environment variable URL:', envUrl);
      //   return envUrl;
      // }
      
      // if (nodeEnv === 'production') {
      //   console.log('Config: Using production URL:', this.production);
      //   return this.production;
      // }
      
      // console.log('Config: Using development URL:', this.development);
      // return this.development;
    }
  },
  
  // Feature flags
  features: {
    enableVoiceInput: true,
    enableLearningIndicators: true,
    enableQuickQueries: true,
    enableKnowledgeStats: true
  },
  
  // UI Configuration
  ui: {
    maxMessageLength: 1000,
    typingIndicatorDelay: 500,
    autoScrollDelay: 100,
    sessionTimeout: 30 * 60 * 1000 // 30 minutes
  }
};

export default config;
